/* unplugin-vue-components disabled */import { render } from "./RefreshRedemptionDetail.vue?vue&type=template&id=3fd9f3e6"
import script from "./RefreshRedemptionDetail.vue?vue&type=script&lang=js"
export * from "./RefreshRedemptionDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__